
<template>
  <div style="display:flex;flex-direction: column;height: 100vh;font-size: 18rem;" @contextmenu.prevent>
    <div class="horizontal" style="justify-content: space-between;padding:20rem;">
      <div style="font-size:30rem;font-weight: 600;">洗碳智能(v2)</div>
      <div style="font-style: italic;">欢迎你:&nbsp;{{userID}}</div>
    </div>
    <div style="background: #eee;height:1rem;width:100%;"></div>
    <div v-if="curCreatePos>=0 && workList[curCreatePos].target_url" style="position: absolute;right:400rem;top:100rem; z-index: 2;">
      <vue-draggable-resizable :w ="150" :onDragStart="onDragStartCallback">
        <div class="horizontal" style="justify-content: space-between;padding: 5rem 0;background: white;">
          <div>视频</div>
          <img v-if="renderingId==workList[curCreatePos].id" class="waitingImg2" src="../assets/zsp/ic_loading.png">
        </div>
        <video-player class="video-player vjs-custom-skin"
          :playsinline="true"
          :options="playerOptions2">
        </video-player>
      </vue-draggable-resizable>
    </div>
    <div ref="gridRef" class="grid">
      <div class="horizontal" ref="gridScale" style="position:fixed;z-index: 2;background: white;">
        <div style="border: 1rem solid black;text-align: center;width:40rem;padding:5rem 10rem;margin-right: 20rem;" @click="scale(0)">放大</div>
        <div style="border: 1rem solid black;text-align: center;width:40rem;padding:5rem 10rem;margin-right: 20rem;" @click="scale(1)">缩小</div>
        <div style="border: 1rem solid black;text-align: center;width:40rem;padding:5rem 10rem;margin-right: 20rem;" @click="render">渲染</div>
        <div style="border: 1rem solid black;text-align: center;width:40rem;padding:5rem 10rem;" @click="save">保存</div>
      </div>
      <div v-if='curCreatePos==-2' style="position:fixed;top:50%;left:50%;transform: translate(-50%, -50%);background:#995;width:200rem;height: 200rem;border-radius: 100rem;z-index: 999;">
        <div style="padding:90rem 20rem;color:white;font-weight: bolder;" @click="createNewVideo">新建一个创意视频</div>
      </div>
      <div class="gridx" v-for="x in gridSizeX" :key="`gridX-${x}`" :style="{ left: x + 'px' }"></div>
      <div class="gridy" v-for="y in gridSizeY" :key="`gridY-${y}`" :style="{ top: y + 'px' }"></div>
      <div style="position:absolute;top:0;left:0;z-index: 1;" id="g6Node"
        @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp"></div>
      <div v-if="showElemPanel" class="popup-panel" :style="{ top: `${popY}px`, left: `${popX}px` }">
        <div v-for="(e,i) in elemTypes" :key="i">
          <div style="padding:10rem 0;" @click="insertNode(i)">{{ e.name }}</div>
          <div style="width:100%;height:1rem;background: #ddd;"></div>
        </div>
        <div style="padding:10rem 0;font-weight: 500;" @click="aiCreate">AI创作</div>
      </div>
      <div v-else-if="nodeIdx>=0" class="popup-panel" :style="{ top: `${popY}px`, left: `${popX}px` }">
        <div class="horizontal" style="justify-content: space-between;">
          <div style="font-weight: bolder;">{{ tmpNodeData.elemType.name }}</div>
          <img v-if="tmpNodeData.status==0" class="waitingImg2" src="../assets/zsp/ic_loading.png">
          <div v-else class="horizontal">
            <div v-if="tmpNodeData.prompt != null" class="option" :style="{'background': optIdx==0?'#bbb':'#f6f6f6'}" @click="optIdx=(optIdx==0?-1:0)">AI生成</div>
            <div v-if="tmpNodeData.elemType.id != 'D'" class="option" :style="{'background': optIdx==1?'#bbb':'#f6f6f6'}" @click="optIdx=(optIdx==1?-1:1)">本地上传</div>
          </div>
        </div>

        <div style="width:450rem;border: 1rem solid #ddd;margin-top:5rem;position: relative;">
          <textarea v-if="optIdx==0" v-model="tmpNodeData.prompt" style="width:430rem;height:200rem;padding:8rem;border: none;resize: none;"></textarea>
          <div v-if="optIdx==0" style="position: absolute;bottom:5rem;right:5rem;color:#459cf1;" @click="generate1">智能生成</div>
          <input v-if="optIdx==1" type="file" style="margin:20rem 10rem;" v-bind:accept="tmpNodeData.elemType.fileType" @change="checkFile" />
          <div v-if="optIdx==1 && select_file" style="margin:20rem 10rem;background: #ddd;width:85rem;padding: 5rem 10rem;text-align: center;" @click="uploadFile">点击上传</div>

          <div v-if="optIdx<0 && tmpNodeData.status != 0 && tmpNodeData.src">
            <img v-if="tmpNodeData.elemType.id=='A'" style="display:block;width: 450rem;" v-bind:src="tmpNodeData.src" alt="">
            <div v-if="tmpNodeData.elemType.id=='B'" style="width: 450rem;">
              <video-player class="video-player vjs-custom-skin"
                :playsinline="true"
                :options="playerOptions1">
              </video-player>
            </div>
            <div v-if="tmpNodeData.elemType.id=='C'" class="horizontal" style="margin:20rem 10rem;display: flex;width: 420rem;">
              <img style="display: block;width:30rem;padding-right: 10rem;" v-bind:src="playicon" @click="playAudio(tmpNodeData.src)">
              <van-slider style="flex: 1;" active-color='#459cf1' button-size='10rem' v-model="progressvalue"
                @change="onProgressChange" @drag-start="dragStart" @drag-end="dragEnd"/>
              <div style="padding-left: 10rem;color:#999;">{{progressstr}}</div>
            </div>
            <div v-if="tmpNodeData.elemType.id=='D'" class="horizontal" style="margin:10rem;">
              <div style="overflow-y: auto;max-height:400rem;">
                <div v-for="(e,i) in tmpNodeData.srts" :key="i">
                  <div class="horizontal" style="display: flex;width:100%;padding-bottom:10rem;">
                    <div style="width:55rem;">{{ e.start.toFixed(1) }}</div>
                    <div style="width:55rem;">{{ (e.start + e.length).toFixed(1) }}</div>
                    <div style="flex: 1;" 
                      :style="{'color':(sound && sound.seek()>e.start && sound.seek()<(e.start + e.length))?'blue':'black'}">
                      {{ e.text }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="horizontal" style="margin-top: 10rem;display: flex;width:420rem;">
                <img style="display: block;width:30rem;padding-right: 10rem;" v-bind:src="playicon" @click="playAudio(tmpNodeData.src)">
                <van-slider style="flex: 1;" active-color='#459cf1' button-size='10rem' v-model="progressvalue"
                  @change="onProgressChange" @drag-start="dragStart" @drag-end="dragEnd"/>
                <div style="padding-left: 10rem;color:#999;">{{progressstr}}</div>
              </div>
            </div>

            <div style="background: #eee;height:1rem;width:100%;"></div>
            <div class="horizontal" style="width:450rem;margin:10rem 0;overflow: auto;font-size: 16rem;">
              <div style="width:100rem; margin:10rem;">
                <div style="padding-bottom: 5rem;">起始时间(秒):</div>
                <input style="width:100%" v-model="tmpNodeData.tmSt"/>
              </div>
              <div style="width:100rem; margin:10rem;">
                <div style="padding-bottom: 5rem;">时长(秒):</div>
                <input style="width:100%" v-model="tmpNodeData.tmDur"/>
              </div>
            </div>
            <div class="horizontal" style="margin:10rem 50rem;justify-content: space-between;">
              <div class="option" @click="confirmInsert">确认使用</div>
              <div class="option" @click="nodeDelete">删除元素</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="showAiCreater" class="popup-panel" style="top:10%;left:15%;width:70%;height:80%;display: flex;flex-direction: column">
        <div class="horizontal" style="justify-content: space-between;">
          <div style="font-weight: bolder;">AI创作</div>
          <img v-if="aiCreaterData.status==0" class="waitingImg2" src="../assets/zsp/ic_loading.png">
          <div v-else class="option">
            <span v-if="aiCreaterData.step==0" @click="generate2">文本生成</span>
            <span v-if="aiCreaterData.step==1" @click="generate3">素材生成</span>
            <span v-if="aiCreaterData.step==2" @click="generate4">确认</span>
          </div>
        </div>
        <div style="margin-top:5rem;width:100%;flex:1;border: 1rem solid #ddd;overflow-y: auto;">
          <textarea v-if="aiCreaterData.step==0" v-model="aiCreaterData.prompt1" style="width:100%;height:100%;border: none;resize: none;"></textarea>
          <textarea v-if="aiCreaterData.step==1" v-model="aiCreaterData.prompt2" style="width:100%;height:100%;border: none;resize: none;"></textarea>
          <div v-if="aiCreaterData.step==2" class="horizontal">
            <div v-for="(e,i) in aiCreaterData.contents" :key="i" style="width:50%;">
              <img v-if="e.image_url" style="display: block;width:95%; padding:10rem;" v-bind:src="e.image_url">
              <div v-if="e.audio_url" class="horizontal" style="display: flex;width:95%; padding:10rem;">
                <img style="display: block;width:30rem;padding-right:10rem;" v-bind:src="playicon" @click="playAudio(e.audio_url)">
                <van-slider style="flex:1;" active-color='#459cf1' button-size='10rem' v-model="progressvalue"
                  @change="onProgressChange" @drag-start="dragStart" @drag-end="dragEnd"/>
                <div style="padding-left: 10rem;color:#999;">{{progressstr}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="aiCreaterData.status!=0 && aiCreaterData.stepMax>0" class="horizontal" style="justify-content: space-between;margin:10rem 0;color:#459cf1;">
          <div><span v-if="aiCreaterData.step>0" @click="aiCreaterData.step-=1">上一步</span></div>
          <div><span v-if="aiCreaterData.step<aiCreaterData.stepMax" @click="aiCreaterData.step+=1">下一步</span></div>
        </div>
      </div>
    </div>
    
    <div v-if="showHistoryPanel" style="margin: 20rem;">
      <div class="horizontal">
        <img style="width: 25rem;height:15rem;" src="../assets/xitan/bottom_arrow.png" @click="showHistoryPanel = false">
        <div style="color:#666;padding-left: 5rem;" @click="showHistoryPanel = false">收起列表</div>
        <img v-if="renderingId>=0" class="waitingImg2" style="padding-left:5rem;width:20rem" src="../assets/zsp/ic_loading.png">
      </div>
      <div class="horizontal" style="background: white;max-height: 300rem;width:100%;overflow: auto;">
        <div>
          <img style="display: block;width:140rem;height:140rem;margin:15rem 15rem 0 0;border-radius: 8rem;" src="../assets/xitan/default_pic1.jpg" @click="createNewVideo">
          <div style="padding-top:5rem;font-size:14rem;">&nbsp;</div>
        </div>
        <div v-for="(e,i) in workList" :key="i" style="position: relative;" @mouseenter="mouse_idx=i" @mouseleave="mouse_idx=-1">
          <img style="display: block;width:140rem;height:140rem;margin:15rem 15rem 0 0;border-radius: 8rem;" src="../assets/xitan/default_pic2.jpg"
          :style="{'border':i==curCreatePos ? '1px solid blue':'none'}" @click="gotoId(i)" draggable="false">
          <div style="padding-top:5rem;font-size:14rem;">{{ e.description }}</div>
          <img v-if="mouse_idx==i" style="position: absolute;right: 15rem;top:15rem;display: block;width: 30rem;" src="../assets/xitan/delete-icon.png" @click="deleteVideo(i)">
        </div>
      </div>
    </div>
    <div v-else class="horizontal" style="position: absolute;bottom:0;margin:50rem 20rem;">
      <img style="width: 25rem;height:15rem;" src="../assets/xitan/top_arrow.png" @click="showHistoryPanel = true">
      <div style="color:#666;padding-left: 5rem;" @click="showHistoryPanel = true">创意列表</div>
      <img v-if="renderingId>=0" class="waitingImg2" style="padding-left:5rem;width:20rem" src="../assets/zsp/ic_loading.png">
    </div>
  </div>
</template>

<script>
import G6 from '@antv/g6'
import {Howl} from 'howler'
import axios from 'axios'
import { PLAY_OPTION,prompt_example } from '../components_wav2lip/util'
import { Toast } from 'vant'

export default {
  data() {
    return {
      email:"test01@example.com",
      userID:"asdfg0",

      gridSizeX: Array.from({ length: 201 }, (_, i) => i * 10),
      gridSizeY: Array.from({ length: 20 }, (_, i) => (i + 1) * 50),

      playerOptions1:PLAY_OPTION,
      playerOptions2:PLAY_OPTION,

      elemTypes: [{
        id:'A',
        color:'#955',
        name:"图片",
        fileType:".jpg, .jpeg, .png"
      },{
        id:'B',
        color:'#595',
        name:"视频",
        fileType:".mp4"
      },{
        id:'C',
        color:'#559',
        name:"音频",
        fileType:".mp3, .wav, .acc"
      },{
        id:'D',
        color:'#999',
        name:"字幕",
        fileType:null
      }],

      showElemPanel:false,
      showAiCreater:false,
      showHistoryPanel:false,
      nodeIdx:-1,
      mouse_idx:-1,

      isClick:false,
      popX:0,
      popY:0,
      addedNodeCount:1,
      unitsec:1.0,
      unitsec_bak:1.0,
    
      optIdx:-1,
      select_file:null,

      curCreatePos:-1,
      renderingId:-1,

      aiCreaterData:{
        step:0,
        stepMax:0,
        status:-1,

        prompt1:"",
        prompt2:"",
        contents:[]
      },
      tmpNodeData:{},

      workList:[],
      data:null,
      graph:null,

      playicon:require("../assets/xitan/audio-icon-play.png"),
      progressvalue:0,
      progressstr:"00:00",
      sound: null,
      sound_url:"",
      touching:false
    }
  },

  created() {
    document.title = '洗碳智能'
    this.getRouterData()
  },
  mounted() {
    this.initG6()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    this.sound && this.sound.stop()
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    getRouterData(){
      this.videoList()
      //this.userLogin()
    },
    async userLogin(){
      console.log("userLogin")

      let request_data = {
        email:this.email
      }
      await axios.post("http://tongtu.tech:8000/api/v1/auth/login", JSON.stringify(request_data),{
          headers: {
            'Content-Type': 'application/json',
          },})
        .then((result) => {
          console.log(result.data)
        }).catch((error) => {
          console.log(error)
          Toast("返回失败2!")
        })
    },
    callServer(url,request_data){
      return new Promise((resolve) => {
        axios.post(url, JSON.stringify(request_data),{
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJlbWFpbCI6InRlc3QwMUBleGFtcGxlLmNvbSIsImV4cCI6MTcxMTgwNzI3MX0.wyjheBvxGIAhMViUi8TLDqugP42vc7bna-hHVvkqpI8' 
          },})
        .then((result) => {
          console.log(result.data)
          if(result.data.code==0){
            resolve(result.data)
          } else {
            resolve(null)
            Toast("返回失败1!")
          }
          
        }).catch((error) => {
          console.log(error)
          resolve(null)
          Toast("返回失败2!")
        })
      });
    },
    getAudioLength(audio_url) {
      return new Promise((resolve) => {
        const audio = new Audio(audio_url);
        audio.addEventListener('loadedmetadata', () => {
          resolve(audio.duration);
        });
      });
    },

    handleResize(){
      const container = this.$refs.gridRef
      const rect = container.getBoundingClientRect()

      const gridScale = this.$refs.gridScale
      gridScale.style.top = rect.top + 'px'
      gridScale.style.left = rect.left + 'px'
    },
    scale(mode){
      if(mode==0 && this.unitsec>0.5){
        this.unitsec -= 0.1
      }
      else if(mode==1 && this.unitsec<2.5){
        this.unitsec += 0.1
      }
      else {
        return
      }
      this.unitsec_bak = this.unitsec
      for(var i=0;i<this.data.nodes.length;i+=1){
        this.data.nodes[i].size = [parseInt(this.data.nodes[i].tmDur*10/this.unitsec_bak), 20]
        this.data.nodes[i].x = this.data.nodes[i].tmSt*10/this.unitsec_bak + this.data.nodes[i].size[0]/2
        const item = this.graph.findById(this.data.nodes[i].id)
        this.graph.updateItem(item, this.data.nodes[i])
      }
      this.graph.refreshPositions()
    },

    handleMouseDown(event){
      if(this.curCreatePos<0) return
      if(this.nodeIdx>=0 && this.tmpNodeData.status==0) return

      const container = this.$refs.gridRef
      const rect = container.getBoundingClientRect() 

      this.popX = event.clientX - rect.left + container.scrollLeft
      this.popY = event.clientY - rect.top + container.scrollTop
      this.popY = Math.round(this.popY/50)*50
      this.popY = Math.max(50,this.popY)
      this.popY = Math.min(1000,this.popY)

      if(this.showElemPanel || this.nodeIdx>=0 || this.showAiCreater){
        if(this.nodeIdx>=0 && this.tmpNodeData.label==""){
          const item = this.graph.findById(this.tmpNodeData.id)
          this.graph.removeItem(item)
          this.data.nodes.splice(this.nodeIdx,1)
          this.addedNodeCount -= 1
        }
        this.sound && this.sound.stop()

        this.showElemPanel = false
        this.nodeIdx = -1
        this.showAiCreater = false

        this.isClick = false
      } else {
        this.isClick = true
      }
      console.log(this.popX,this.popY)
    },
    handleMouseMove(){
      this.isClick = false
    },
    handleMouseUp(){
      if(this.isClick && this.nodeIdx<0){
        this.showElemPanel = true
      }
    },
    onDragStartCallback(event){
      event.preventDefault()
    },
    nodeDelete(){
      if(this.curCreatePos<0) return
      if(this.tmpNodeData.status==0) return

      const item = this.graph.findById(this.tmpNodeData.id)
      this.graph.removeItem(item)
      this.data.nodes.splice(this.nodeIdx,1)
      this.nodeIdx = -1

      this.update()
    },
    insertNode(index){
      this.showElemPanel = false

      let tmDur = 5.0
      let size_x = parseInt(tmDur*10/this.unitsec_bak)
      var newNode = {
        x: this.popX + size_x/2,
        y: this.popY,
        size: [size_x, 20],
        type: 'rect',
        id: this.elemTypes[index].id + this.addedNodeCount,
        label:"",
        tmSt: this.popX/10*this.unitsec_bak,
        tmDur: tmDur,
        elemType: this.elemTypes[index],
        style:{
          fill:this.elemTypes[index].color,
          radius: 5,
          stroke:'#fff',
          lineWidth: 1
        }
      }
      this.optIdx = 1
      if(newNode.elemType.id=='A'){
        this.optIdx = 0
        newNode.prompt = "a little girl is walking on the street"
      } else if(newNode.elemType.id=='D'){
        this.optIdx = 0
        newNode.prompt = "请在这里输入你的文案，并合成声音"
      }

      this.graph.addItem('node', newNode)
      this.data.nodes.push(newNode)
      this.addedNodeCount++

      this.select_file = null
      this.nodeIdx = this.data.nodes.length - 1
      this.tmpNodeData = JSON.parse(JSON.stringify(newNode))
    },
    confirmInsert(){
      if(this.curCreatePos<0) return
      if(this.tmpNodeData.status==0 || this.tmpNodeData.status==-1) return
      if(this.tmpNodeData.tmSt<0
        || this.tmpNodeData.tmSt>180
        || this.tmpNodeData.tmDur<0.1
        || this.tmpNodeData.tmDur>180){
          //
          Toast("数值错误")
          return
        }

      if(this.tmpNodeData.label==""){
        this.tmpNodeData.label = this.tmpNodeData.elemType.name + ' ' + this.addedNodeCount
      }
      var srcChange = false
      if(this.tmpNodeData.src != this.data.nodes[this.nodeIdx].src){
        srcChange = true
      }
      var postionChange = false
      if(Math.abs(this.data.nodes[this.nodeIdx].tmDur - this.tmpNodeData.tmDur)>0.001 ||
         Math.abs(this.data.nodes[this.nodeIdx].tmSt - this.tmpNodeData.tmSt)>0.001){
          this.tmpNodeData.size = [parseInt(this.tmpNodeData.tmDur*10/this.unitsec_bak), 20]
          this.tmpNodeData.x = this.tmpNodeData.tmSt*10/this.unitsec_bak + this.tmpNodeData.size[0]/2
          postionChange = true
      }
      this.data.nodes[this.nodeIdx] = JSON.parse(JSON.stringify(this.tmpNodeData))
      const item = this.graph.findById(this.tmpNodeData.id)
      this.graph.updateItem(item, this.data.nodes[this.nodeIdx])
      this.nodeIdx = -1

      if(postionChange){
        this.graph.refreshPositions()
      }
      if(postionChange || srcChange){
        this.update()
      }
    },
    async generate1(){
      console.log("generate1")

      this.optIdx = -1
      this.tmpNodeData.status = 0
      if(this.tmpNodeData.elemType.id == 'A'){
        let t = await this.callServer("http://tongtu.tech:8000/api/v1/ai/text2image",{
          prompt: this.tmpNodeData.prompt
        })
        if(t==null){
          this.tmpNodeData.status = -1
        } else {
          this.tmpNodeData.status = 1
          this.tmpNodeData.src = t.data.image_url
          this.tmpNodeData = JSON.parse(JSON.stringify(this.tmpNodeData))
        }
      } else if(this.tmpNodeData.elemType.id == 'D'){
        let t = await this.callServer("http://tongtu.tech:8000/api/v1/ai/volc_tts",{
          text: this.tmpNodeData.prompt
        })
        if(t==null){
          this.tmpNodeData.status = -1
        } else {
          this.tmpNodeData.status = 1
          this.tmpNodeData.src = t.data.audio_url
          this.tmpNodeData.srts = t.data.srts
          this.tmpNodeData = JSON.parse(JSON.stringify(this.tmpNodeData))
          this.playAudio(t.data.audio_url)
        }
      }
    },
    async generate2(){
      console.log("generate2")

      this.aiCreaterData.step = 1
      this.aiCreaterData.stepMax = Math.max(this.aiCreaterData.step,this.aiCreaterData.stepMax)

      this.aiCreaterData.status = 0
      let t = await this.callServer("http://tongtu.tech:8000/api/v1/ai/az_openai_gpt",{
        prompt: this.aiCreaterData.prompt1
      })
      if(t==null){
        this.aiCreaterData.status = -1
      } else {
        this.aiCreaterData.status = 1
        this.aiCreaterData.prompt2 = t.data.message
      }
    },
    async generate3(){
      console.log("generate3")

      var tjson = {}
      try {
        tjson = JSON.parse(this.aiCreaterData.prompt2)
      } catch (error) {
        Toast("Json解析失败!")
        return
      }
      this.aiCreaterData.status = 0
      this.aiCreaterData.step = 2
      this.aiCreaterData.stepMax = Math.max(this.aiCreaterData.step,this.aiCreaterData.stepMax)

      let lst = tjson.content_list
      this.aiCreaterData.contents.length = 0

      for(var i=0;i<lst.length;i+=1){
        this.aiCreaterData.contents.push({})
        //
        let t1 = await this.callServer("http://tongtu.tech:8000/api/v1/ai/text2image", {
          prompt:lst[i].text2image_prompt
        })
        if(t1==null){
          this.aiCreaterData.status = -1
          return
        } else {
          this.aiCreaterData.contents[i].image_url = t1.data.image_url
          this.aiCreaterData.contents[i].text2image_prompt = lst[i].text2image_prompt
        }
        //
        let t2 = await this.callServer("http://tongtu.tech:8000/api/v1/ai/volc_tts", {
          text:lst[i].text2voice_prompt
        })
        if(t2==null){
          this.aiCreaterData.status = -1
          return
        } else {
          this.aiCreaterData.contents[i].audio_url = t2.data.audio_url
          this.aiCreaterData.contents[i].srts = t2.data.srts
          this.aiCreaterData.contents[i].text2voice_prompt = lst[i].text2voice_prompt
        }
        this.aiCreaterData.contents[i].audio_len = await this.getAudioLength(this.aiCreaterData.contents[i].audio_url)
      }
      this.aiCreaterData.status = 1
    },
    generate4(){
      let lst = this.aiCreaterData.contents
      if(lst.length<=0) return
      if(this.aiCreaterData.status == -1) return

      var tmSt = this.popX/10*this.unitsec_bak
      var tmDur = 0
      for(var i=0;i<lst.length;i+=1){
        tmSt = tmSt + tmDur
        tmDur = lst[i].audio_len
        let size_x = parseInt(tmDur*10/this.unitsec_bak)
        let x = parseInt(tmSt*10/this.unitsec_bak + size_x/2)
        //
        var newNode = {
          x: x,
          y: this.popY,
          size: [size_x, 20],
          type: 'rect',
          id: this.elemTypes[0].id + this.addedNodeCount,
          label :this.elemTypes[0].name + ' ' + this.addedNodeCount,
          tmSt: tmSt,
          tmDur: tmDur,
          src:lst[i].image_url,
          prompt:lst[i].text2image_prompt,
          elemType: this.elemTypes[0],

          style:{
            fill:this.elemTypes[0].color,
            radius: 5,
            stroke:'#fff',
            lineWidth: 1
          }
        }
        this.graph.addItem('node', newNode)
        this.data.nodes.push(newNode)
        this.addedNodeCount++
        //
        newNode = {
          x: x,
          y: this.popY + 50,
          size: [size_x, 20],
          type: 'rect',
          id: this.elemTypes[3].id + this.addedNodeCount,
          label :this.elemTypes[3].name + ' ' + this.addedNodeCount,
          tmSt: tmSt,
          tmDur: tmDur,
          src:lst[i].audio_url,
          srts:lst[i].srts,
          prompt:lst[i].text2voice_prompt,
          elemType: this.elemTypes[3],

          style:{
            fill:this.elemTypes[3].color,
            radius: 5,
            stroke:'#fff',
            lineWidth: 1
          }  
        }
        this.graph.addItem('node', newNode)
        this.data.nodes.push(newNode)
        this.addedNodeCount++
      }
      this.showAiCreater = false
      this.update()
    },
    gotoId(index){
      if(this.renderingId>=0 || this.aiCreaterData.status==0 || this.tmpNodeData.status==0){
        Toast("有服务正在执行，无法执行删除操作")
        return
      }
      if(index>=this.workList.length) return

      if(this.workList[index].material==""){
        this.unitsec_bak = 1.0
        this.unitsec = 1.0
        this.data.nodes = []
      } else {
        let t = JSON.parse(this.workList[index].material)
        this.unitsec_bak = t.unitsec_bak
        this.unitsec = this.unitsec_bak
        this.data.nodes = t.nodes
      }
      this.curCreatePos = index
      
      if(this.workList[index].target_url!=""){
        this.playerOptions2.sources=[{
          type: "video/mp4",
          src: this.workList[index].target_url
        }]
      }
      this.addedNodeCount = this.data.nodes.length + 1
      this.graph.data(this.data)
      this.graph.render()

      this.showAiCreater = false
      this.showElemPanel = false
    },
    checkFile(event) {
      if(event.target.files.length>0){
        this.select_file = event.target.files[0]
        console.log(this.select_file.name)
      }
    },
    async uploadFile(){
      console.log("uploadFile")

      if(this.select_file.size > 60 * 1024 * 1024) {
        Toast("文件限制,超过了60M")
        return
      }
      this.optIdx = -1
      this.tmpNodeData.status = 0

      const formData = new FormData();
      formData.append("file", this.select_file)
      await axios
        .post("https://caixiaowen.com/zsp", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data)
          if(response.data.err_no==0){
            this.tmpNodeData.src = response.data.file_url
            if(this.tmpNodeData.elemType.id=='B'){
              this.playerOptions1.sources=[{
                type: "video/mp4",
                src: this.tmpNodeData.src
              }]
            } else if(this.tmpNodeData.elemType.id=='C'){
              this.playAudio(this.tmpNodeData.src)
            }
            this.tmpNodeData.status = 1
            //this.tmpNodeData = JSON.parse(JSON.stringify(this.tmpNodeData))
          }else {
            this.tmpNodeData.status = -1
            Toast("返回失败1!")
          }
        })
        .catch((error) => {
          console.error(error)
          this.tmpNodeData.status = -1
          Toast("返回失败2!")
        })
    },

    async createNewVideo(){
      if(this.renderingId>=0 || this.aiCreaterData.status==0 || this.tmpNodeData.status==0){
        Toast("有服务正在执行，无法执行删除操作")
        return
      }
      console.log("createNewVideo")

      const now = new Date()
      let title = now.toLocaleString()
      let t = await this.callServer("http://tongtu.tech:8000/api/v1/creativity/create", {
        "data": {
            "description": title
        }
      })
      if(t!=null && t.data != null){
        this.workList.unshift(t.data.data)
        this.gotoId(0)
        this.showHistoryPanel = true
      }
    },
    async deleteVideo(index){
      if(this.renderingId>=0 || this.aiCreaterData.status==0 || this.tmpNodeData.status==0){
        Toast("有服务正在执行，无法执行删除操作")
        return
      }
      console.log("deleteVideo")

      let t = await this.callServer("http://tongtu.tech:8000/api/v1/creativity/delete", {
        id:this.workList[index].id
      })
      if(t!=null){
        this.workList.splice(index, 1)
        if(this.workList.length==0){
          this.curCreatePos = -2
          this.data.nodes=[]
          this.graph.data(this.data)
          this.graph.render()
          this.showHistoryPanel = false
        } else {
          this.gotoId(0)
        }
      }
    },
    async videoList(){
      console.log("videoList")

      await axios.get("http://tongtu.tech:8000/api/v1/creativity/list?page_no=1&page_size=100", {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJlbWFpbCI6InRlc3QwMUBleGFtcGxlLmNvbSIsImV4cCI6MTcxMTgwNzI3MX0.wyjheBvxGIAhMViUi8TLDqugP42vc7bna-hHVvkqpI8' 
          },})
        .then((result) => {
          console.log(result.data)
          if(result.data.code==0){
            if(result.data.data.list.length>0){
              this.workList = result.data.data.list
              this.gotoId(0)
              this.showHistoryPanel = true
            }
            else {
              this.curCreatePos = -2
              this.data.nodes=[]
              this.graph.data(this.data)
              this.graph.render()
              this.showHistoryPanel = false
            }
          } else {
            Toast("返回失败1!")
          }
        }).catch((error) => {
          console.log(error)
          Toast("返回失败2!")
        })
    },
    update(){
      console.log("update")

      this.workList[this.curCreatePos].material = JSON.stringify({
        unitsec_bak:this.unitsec_bak,
        nodes:this.data.nodes
      })

      this.callServer("http://tongtu.tech:8000/api/v1/creativity/update", {
        data:this.workList[this.curCreatePos]
      })
    },
    async render(){
      this.showElemPanel = false

      var scenes = []
      var audios = []
      var subtitles = []
      let lst = this.data.nodes

      var tmStMin = 1000
      for(var i=0;i<lst.length;i+=1){
        if(lst[i].tmSt<tmStMin){
          tmStMin = lst[i].tmSt
        }
      }
      for(i=0;i<lst.length;i+=1){
        if(lst[i].elemType.id=='A' && lst[i].src){
          scenes.push({
            type:"image",
            src:lst[i].src,
            start:lst[i].tmSt - tmStMin,
            length:lst[i].tmDur
          })
        }
        if(lst[i].elemType.id=='D' && lst[i].src){
          subtitles.push({
            src: lst[i].src,
            srts:lst[i].srts,
            start:lst[i].tmSt -tmStMin,
            length:lst[i].tmDur
          })
        }
      }
      this.renderingId = this.workList[this.curCreatePos].id

      let t = await this.callServer("http://tongtu.tech:8000/api/v1/generate/video", {
        creativityId:this.renderingId,
        scenes:scenes,
        audios:audios,
        subtitles:subtitles
      })
      if(t==null){
        this.renderingId = -1
      } else {
        this.renderingId = -1
        this.workList[this.curCreatePos].target_url = t.data.target_url
        this.playerOptions2.sources=[{
          type: "video/mp4",
          src: t.data.target_url
        }]
        this.update()
      }
    },
    save(){
      this.update()
      this.showElemPanel = false
      Toast("已保存")
    },

    aiCreate(){
      this.showElemPanel = false
      this.showAiCreater = true

      this.aiCreaterData.step = 0
      this.aiCreaterData.stepMax = 0
      this.aiCreaterData.status = -1
      this.aiCreaterData.prompt1 = prompt_example
      this.aiCreaterData.prompt2 = ""
      this.aiCreaterData.contents = []
    },

    initG6() {
      console.log("initG6...")
      this.data = {
        nodes: [],
        edges: []
      },
      this.graph = new G6.Graph({
        container: 'g6Node',
        width: 2000,
        height: 1050,
        modes: {
            default: ['drag-node', 'click-select']
        },
        defaultNode: {
          labelCfg: { 
            positions: 'center',
            style: {
              fontSize: 10,
              fill:'#fff'
            }
          }
        },
        nodeStateStyles: {
          // 节点在 selected 状态下的样式，对应内置的 click-select 行为
          selected: {
            stroke: '#fff',
            lineWidth: 1,
            radius: 5,
            fill: 'steelblue'
          }
        }
      }),
      this.graph.data(this.data)
      this.graph.render()

      this.graph.on('node:click', (event) => {
        if(this.nodeIdx>=0 || this.showAiCreater || this.showElemPanel) return
        this.optIdx = -1
        const itemId = event.item.getModel().id
        for(var i=0;i<this.data.nodes.length;i+=1){
          if (this.data.nodes[i].id == itemId){
            this.nodeIdx = i
            this.tmpNodeData = JSON.parse(JSON.stringify(this.data.nodes[i]))
            console.log("select ",i)
            break
          }
        }
      });

      this.graph.on('node:dragend', (event) => {
        const itemId = event.item.getModel().id
        for(var i=0;i<this.data.nodes.length;i+=1){
          if (this.data.nodes[i].id == itemId){
            var { x, y } = event.item.getModel()
            y = Math.round(y/50)*50
            y = Math.max(50,y)
            y = Math.min(1000,y)
            console.log("drag ",i,x,y)

            this.data.nodes[i].x = x
            this.data.nodes[i].y = y
            this.data.nodes[i].tmSt = (x-this.data.nodes[i].size[0]/2)/10*this.unitsec_bak
            this.graph.updateItem(event.item, this.data.nodes[i])
            this.graph.refreshPositions()
            this.update()

            break
          }
        }
      });
    },

    getPosition() {
      var duration = this.sound.duration()
      if(duration>0) {
        this.progressvalue = this.sound.seek()*100/duration

        let rest = duration - this.sound.seek()
        var t1=parseInt(rest/60)
        if(t1<10)t1='0'+t1
        var t2=parseInt(rest%60)
        if(t2<10)t2='0'+t2
        this.progressstr = ''+t1+':'+t2
      }
      var s = this.sound.playing()
      if(!s) {
        this.playicon=require('../assets/xitan/audio-icon-play.png')
      }
      if( s && !this.touching) {
        requestAnimationFrame(this.getPosition)
      }
    },
    playAudio(wav) {
      if(wav != null && this.sound_url != wav) {
        console.log("initial sound",wav)
        this.sound_url = wav
        this.sound && this.sound.stop()
        this.sound = new Howl({
          src: [wav],

          onplay:() => {
            console.log("开始播放啦")
            this.playicon=require('../assets/xitan/audio-icon-pause.png')
            requestAnimationFrame(this.getPosition)
          },
          onloaderror:() => {
            Toast("声音导入失败")
          },
          onplayerror:() => {
            Toast("声音播放失败")
          },
        })
      }
      this.sound && this.sound[this.sound.playing()? 'pause' : 'play']()
    },
    onProgressChange() {
      var sec=this.sound?this.progressvalue*this.sound.duration()/100:0
      console.log("change to",this.progressvalue,sec)
      
      this.sound && this.sound.seek(sec)
    },
    dragStart() {
      this.touching = true
    },
    dragEnd() {
      this.touching = false
      if(this.sound!=null) {
        requestAnimationFrame(this.getPosition)
      }
    },
  }
}
</script>

<style scoped>

.horizontal {
  flex-direction: row;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: center;
}

.grid {
  position: relative;
  width:1600rem;
  flex: 1;
  margin:20rem auto;
  border: 1rem solid #ccc;
  overflow: auto;
}

.gridx {
  position: absolute;
  background: #eee;
  width: 1px;
  height: 1050px;
}

.gridy {
  position: absolute;
  background: #444;
  height: 1px;
  width: 2000px;
}
.popup-panel {
  position: absolute;
  background: #fff;
  border: 1px solid #eee;
  min-width: 45px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.option {
  color:#459cf1;
  background: #f6f6f6;
  padding:5rem 10rem;
  text-align: center;
  width:80rem;
  border:1rem solid gray;
}

.waitingImg2 {
  display: block;
  width: 30rem;
  animation: rotateImg 8s linear infinite;
}
@keyframes rotateImg {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>
